module.exports = __webpack_public_path__ + "static/casketBanner-00f4cb6e7343935283a61a9fe0e6e76a.jpg";